
export default {
    getPapel(state) {
        return state.papel
    },
    getPapeis(state) {
        return state.papeis
    },
}